/**
 * Shop by Category section
 * Vanilla JS, namespaced, supports multiple instances per page and the
 * Shopify Theme Editor's section/block lifecycle events.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-shop-by-category]';
  var REVEAL_SELECTOR = '[data-reveal]';
  var VISIBLE_CLASS = 'shop-by-category__reveal--visible';

  function ShopByCategory(root) {
    this.root = root;
    this.revealEls = Array.prototype.slice.call(root.querySelectorAll(REVEAL_SELECTOR));
    this.observer = null;

    this.handleBlockSelect = this.handleBlockSelect.bind(this);

    this.setupObserver();
    this.root.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  ShopByCategory.prototype.setupObserver = function () {
    if (!this.revealEls.length) return;

    if (!('IntersectionObserver' in window)) {
      this.revealEls.forEach(function (el) {
        el.classList.add(VISIBLE_CLASS);
      });
      return;
    }

    var self = this;
    this.observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(VISIBLE_CLASS);
            self.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    this.revealEls.forEach(function (el) {
      this.observer.observe(el);
    }, this);
  };

  ShopByCategory.prototype.handleBlockSelect = function (event) {
    var block = event.target.closest ? event.target.closest('[data-reveal]') : null;
    if (!block) return;
    // Reveal instantly when a merchant selects a card in the theme editor,
    // even if it hasn't scrolled into view yet.
    block.classList.add(VISIBLE_CLASS);
    block.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  ShopByCategory.prototype.destroy = function () {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.root.removeEventListener('shopify:block:select', this.handleBlockSelect);
  };

  function initSections(scope) {
    var context = scope || document;
    var roots = context.matches && context.matches(ROOT_SELECTOR)
      ? [context]
      : Array.prototype.slice.call(context.querySelectorAll(ROOT_SELECTOR));

    roots.forEach(function (root) {
      if (!root.shopByCategoryInstance) {
        root.shopByCategoryInstance = new ShopByCategory(root);
      }
    });
  }

  function teardownSections(scope) {
    var context = scope || document;
    var roots = context.matches && context.matches(ROOT_SELECTOR)
      ? [context]
      : Array.prototype.slice.call(context.querySelectorAll(ROOT_SELECTOR));

    roots.forEach(function (root) {
      if (root.shopByCategoryInstance) {
        root.shopByCategoryInstance.destroy();
        root.shopByCategoryInstance = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSections(document);
    });
  } else {
    initSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    teardownSections(event.target);
  });
})();